import React from "react"

export default function RoleList({ data, editRole, editMenuPermission, deleteRole }) {
    return (
        <>
            <div className="table-responsive table-hover table-sales">
                <table className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">No.</th>
                            <th scope="col">Name</th>
                            <th scope="col">Description</th>
                            <th scope="col">Status</th>
                            <th scope="col">Menu</th>
                            <th scope="col">Edit</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((item, index) => {
                                let status = ''
                                let statusClass = ''
                                if (item.status === 'A') {
                                    status = 'Active'
                                    statusClass = 'text-center text-success'
                                } else if (item.status === 'I') {
                                    status = 'Inactive'
                                    statusClass = 'text-center text-secondary'
                                }

                                return (
                                    <tr key={item.id}>
                                        <td>{index+1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.description}</td>
                                        <td><span className={statusClass}>{status}</span></td>
                                        <td><button type="button" className="btn btn-link text-success" onClick={editMenuPermission.bind(this, item)}><i className="bi bi-list-check me-2" title="Menu"></i></button></td>
                                        <td><button type="button" className="btn btn-link text-primary" onClick={editRole.bind(this, item.id)}><i className="bi bi-pencil me-2" title="Edit"></i></button></td>
                                        <td><button type="button" className="btn btn-link text-danger" onClick={deleteRole.bind(this, item.id, item.name)}><i className="bi bi-trash" title="Delete"></i></button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}